import { Action } from 'redux';

import { isSpaceContentsNextPageWithTokenSuccededAction,isSpaceContentsUpdateTotalCountAction,isSpaceContentsWithTokenRequestSucceededAction } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';


export function contentTotalCountReducer(
  previousState: number = 0,
  action: Action = null
): number {
  if ((isSpaceContentsWithTokenRequestSucceededAction(action) || isSpaceContentsNextPageWithTokenSuccededAction(action))
       && action?.contentWithToken?.total) {
    return action.contentWithToken.total;
  } else if (isSpaceContentsUpdateTotalCountAction(action) && action && action.totalCount !== undefined) {
    return action.totalCount;
  }

  return previousState;
}

